import { SnackbarTypes } from '../action/index.model'

export interface ISnackbar {
  open: boolean
  message: string
  type: string
}

const initialState: ISnackbar = {
  open: false,
  message: '',
  type: '',
}
const SnackbarReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SnackbarTypes.SNACKBAR_SUCCESS:
      return {
        ...state,
        open: true,
        message: action.data,
        type: 'success',
      }
    case SnackbarTypes.SNACKBAR_FAIL:
      return {
        ...state,
        open: true,
        message: action.data,
        type: 'fail',
      }
    case SnackbarTypes.SNACKBAR_INFO:
      return {
        ...state,
        open: true,
        message: action.data,
        type: 'info',
      }
    case SnackbarTypes.SNACKBAR_RESET:
      return {
        ...state,
        open: false,
        message: '',
        type: '',
      }
    default:
      return state
  }
}

export default SnackbarReducer
